module.exports = __webpack_public_path__ + "static/media/post-05.19d47a15.png";